import { Injectable } from '@angular/core';
import {HttpClient,HttpHeaders} from "@angular/common/http";
/*import { AngularFireAuth } from '@angular/fire/auth';
import { AngularFirestore, AngularFirestoreCollection } from 'angularfire2/firestore';
import * as firebase from 'firebase/app'*/



@Injectable({
  providedIn: 'root'
})
export class ConexionesService {
 // dbCollection:AngularFirestoreCollection<any>;
  arreglo:any;
  //ruta:string;
 
  constructor(//private db:AngularFirestore,
              //public afAuth: AngularFireAuth
              private http:HttpClient
              ) {}

        /*    getIp() {

              var promise = new Promise((resolve, reject) => {
                this.http.get('https://api.ipregistry.co/?key=o88tv7pj3wn7b24n').subscribe((data) => {

                  resolve(data)
                })
              })
              return promise;

            }*/
  enviaCorreo(tema, subtema, nombre, fechanac, telefono,
    email, nivel, oficio, labora, empresa, labora2,
    dependencia, institucion, miembroosc, nombreosc,estudia,testdata) {
console.log(testdata)


  //  console.log('https://nld.gob.mx/php/enviaCorreo.php?nombre=' + nombre + '&tema=' + tema + '&subtema=' + subtema + '&fechanac=' + fechanac + '&telefono=' + telefono + '&email=' + email + '&nivel=' + nivel + '&oficio=' + oficio + '&labora=' + labora + '&empresa=' + empresa + '&labora2=' + labora2 + '&dependencia=' + dependencia + '&institucion=' + institucion + '&miembroosc=' + miembroosc + '&nombreosc=' + nombreosc + '&estudia=' + estudia)

    var promise = new Promise((resolve, reject) => {
                this.http.post('https://nld.gob.mx/php/enviaCorreo.php?nombre='+nombre+'&tema='+tema+'&subtema='+subtema+'&fechanac='+fechanac+'&telefono='+telefono+'&email='+email+'&nivel='+nivel+'&oficio='+oficio+'&labora='+labora+'&empresa='+empresa+'&labora2='+labora2+'&dependencia='+dependencia+'&institucion='+institucion+'&miembroosc='+miembroosc+'&nombreosc='+nombreosc+'&estudia='+estudia,testdata).subscribe((data) => {

                  resolve(data)
                })
              })
              return promise;

            }






              getNoticias(){
  
                var promise = new Promise((resolve, reject) => {
                    this.http.get('https://noticias.nld.gob.mx/assets/php/getNoticias.php').subscribe((data)=>{
                     
                        resolve(data)
                    })
                })    
                return promise;
              
              }
              getPosts() {

                var promise = new Promise((resolve, reject) => {
                  this.http.get('https://app.nld.gob.mx/assets/php/getPosts.php').subscribe((data) => {

                    resolve(data)
                  })
                })
                return promise;

              }
              getNoticiasLimit(limit:any){
  
                var promise = new Promise((resolve, reject) => {
                  this.http.get('https://noticias.nld.gob.mx/assets/php/getNoticias.php?limit='+limit).subscribe((data)=>{
                     
                        resolve(data)
                    })
                })    
                return promise;
              
              }
            getTramites(limit: any) {

              var promise = new Promise((resolve, reject) => {
                this.http.get('https://noticias.nld.gob.mx/assets/php/getTramites.php?limit=' + limit).subscribe((data) => {

                  resolve(data)
                })
              })
              return promise;

            }
  getFolioEE(folio: any) {

    var promise = new Promise((resolve, reject) => {
      this.http.get('https://becas2026.nld.gob.mx/php/getEstatusBecaEE.php?folio=' + folio).subscribe((data) => {

        resolve(data)
      })
    })
    return promise;

  }
              /*, nombre: any, apaterno: any, amaterno: any*/
            getFolioBeca(folio: any) {

              console.log()

              var promise = new Promise((resolve, reject) => {
                this.http.get('https://becas2023.nld.gob.mx/assets/php/getEstatusBeca.php?folio=' + folio).subscribe((data) => {

                  resolve(data)
                })
              })
              return promise;

            }
            getFolioBeca2024(folio: any) {

              var promise = new Promise((resolve, reject) => {
                this.http.get('https://becasnuevaera2025.nld.gob.mx/assets/php/getEstatusBeca2024.php?folio=' + folio).subscribe((data) => {

                  resolve(data)
                })
              })
              return promise;

            }
          getFolioBecaBTD(folio: any) {

            var promise = new Promise((resolve, reject) => {
              this.http.get('https://becasnuevaera2025.nld.gob.mx/assets/php/getEstatusBeca2024s.php?folio=' + folio).subscribe((data) => {

                resolve(data)
              })
            })
            return promise;

          }
          getFolioBecaBDAC(folio: any) {

            var promise = new Promise((resolve, reject) => {
              this.http.get('https://becasnuevaera2025.nld.gob.mx/assets/php/getEstatusBeca2024s2.php?folio=' + folio).subscribe((data) => {

                resolve(data)
              })
            })
            return promise;

          }
            getFolioBeca2025(folio: any) {

              var promise = new Promise((resolve, reject) => {
                this.http.get('https://becasnuevaera2025.nld.gob.mx/assets/php/getEstatusBeca2025.php?folio=' + folio).subscribe((data) => {

                  resolve(data)
                })
              })
              return promise;

            }
            getFolioBecaUniversitaria(folio: any) {

              var promise = new Promise((resolve, reject) => {
                this.http.get('https://becasnuevaera2025.nld.gob.mx/assets/php/getEstatusBecaUniversitaria.php?folio=' + folio).subscribe((data) => {

                  resolve(data)
                })
              })
              return promise;

            }
          getFolioBecaUniversitaria2(folio: any) {

            var promise = new Promise((resolve, reject) => {
              this.http.get('https://becasnuevaera2025.nld.gob.mx/assets/php/getEstatusBecaUniversitaria2.php?folio=' + folio).subscribe((data) => {

                resolve(data)
              })
            })
            return promise;

          }
          getFolioTitulacionProf(folio: any) {

            var promise = new Promise((resolve, reject) => {
              this.http.get('https://becasnuevaera2025.nld.gob.mx/assets/php/getEstatusBecaTitulacionProf.php?folio=' + folio).subscribe((data) => {

                resolve(data)
              })
            })
            return promise;

          }
  getClave2025(folio: any) {

    var promise = new Promise((resolve, reject) => {
      this.http.get('https://becasnuevaera2025.nld.gob.mx/assets/php/getClaveTrabajo.php?folio=' + folio).subscribe((data) => {

        resolve(data)
      })
    })
    return promise;

  }
  getClave2025_maestros(folio: any) {

    var promise = new Promise((resolve, reject) => {
      this.http.get('https://apoyosmaestros.nld.gob.mx/assets/php/getEstatusApoyo.php?folio=' + folio).subscribe((data) => {

        resolve(data)
      })
    })
    return promise;

  }
  getVisitantes() {

    var promise = new Promise((resolve, reject) => {
      this.http.get('https://becas2023.nld.gob.mx/assets/php/getVisitantes.php').subscribe((data) => {

        resolve(data)
      })
    })
    return promise;

  }
            getFolioApoyo(folio: any, nombre: any, apaterno: any, amaterno: any) {
              console.log('https://becas2022.nld.gob.mx/assets/php/getEstatusApoyo.php?folio=' + folio + '&nombre=' + nombre + '&apaterno=' + apaterno + '&amaterno=' + amaterno)
              var promise = new Promise((resolve, reject) => {
                this.http.get('https://becas2022.nld.gob.mx/assets/php/getEstatusApoyo.php?folio=' + folio + '&nombre=' + nombre + '&apaterno=' + apaterno + '&amaterno=' + amaterno).subscribe((data) => {

                  resolve(data)
                })
              })
              return promise;

            }

          getClima() {

            var promise = new Promise((resolve, reject) => {
              this.http.get('https://api.openweathermap.org/data/2.5/weather?q=Nuevo%20Laredo&appid=3fed35c07341f198551df8460a16a83e&units=metric').subscribe((data) => {

                resolve(data)
              })
            })
            return promise;

          }
  /*guardaFactura(data){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/x-www-form-urlencoded'
      })
    };

     var promise = new Promise((resolve, reject) => {
      this.http.post('https://indeweb.net/csa/assets/php/guardaFactura.php', data,httpOptions).subscribe((resp:any)=>{
  
      if(resp.status){
          resolve(true)
        }else{
          resolve(false)
        }
    
      })
    
    });
    return promise;
  }
  getCargos(idchofer){
  
    var promise = new Promise((resolve, reject) => {
        this.http.get('https://indeweb.net/csa/assets/php/getCargos.php?idchofer='+idchofer).subscribe((data)=>{
         
            resolve(data)
        })
    })    
    return promise;
  
  }
  addPago(formaPago,idchofer){
  
    var promise = new Promise((resolve, reject) => {
        this.http.get('https://indeweb.net/csa/assets/php/addPago.php?idchofer='+idchofer+"&tipoPago="+formaPago).subscribe((data)=>{
         
            resolve(data)
        })
    })    
    return promise;
  
  }
  subeDoc(file,tipo,id){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'multipart/form-data'
      })
    };
    console.log(file.get("file"))

     var promise = new Promise((resolve, reject) => {
      this.http.post('https://indeweb.net/csa/assets/php/subeImagen.php?tipo='+tipo+'&id='+id, file,httpOptions)
      .subscribe((resp:any)=>{
      console.log(resp)
      if(resp.status){
          resolve(true)
        }else{
          resolve(false)
        }
    
      },(error)=>{
        console.log(error)
      })
    
    });
    return promise;
  }
  addUsuario(data){
    const httpOptions = {
      headers: new HttpHeaders({
        'Content-Type':  'application/x-www-form-urlencoded'
      })
    };

     var promise = new Promise((resolve, reject) => {
      this.http.post('https://indeweb.net/csa/assets/php/addUsuario.php', data,httpOptions).subscribe((resp:any)=>{
     
      if(resp.status){
          resolve(true)
        }else{
          resolve(false)
        }
    
      })
    
    });
    return promise;
  }
  eliminaUsuario(id){
  
    var promise = new Promise((resolve, reject) => {
        this.http.get('https://indeweb.net/csa/assets/php/deleteUsuario.php?id='+id).subscribe((data)=>{
         
            resolve(data)
        })
    })    
    return promise;
  
  }
  
  getUsuarios(){
  
    var promise = new Promise((resolve, reject) => {
        this.http.get('https://indeweb.net/csa/assets/php/getUsuarios.php').subscribe((data)=>{
         
            resolve(data)
        })
    })    
    return promise;
  
  }*/
  
}
